import { Component } from '@angular/core';
import { AgritourismSignUpFormComponent } from '../../sign-up-form/sign-up-form.component';

@Component({
  selector: 'curbnturf-agritourism-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss'],
  standalone: true,
  imports: [AgritourismSignUpFormComponent],
})
export class AgritourismAuthModalComponent {}
